import { useState, useCallback } from 'react';
import { t } from 'ttag';
import { useStoreActions } from '../../../models/RootStore';

export const use2FA = () => {
  const verify2FA = useStoreActions((a) => a.verify2FA);
  const [open2FADialog, setOpen2FADialog] = useState(false);
  const [error2FA, setError2FA] = useState(null);

  const cancel2FA = useCallback(() => {
    setOpen2FADialog(false);
    setError2FA(null);
  }, []);

  const handleVerify2FA = useCallback((code) => {
    verify2FA({ code })
      .catch((response) => {
        if (response) {
          setError2FA(
            response.message
              ? t`The code you entered is invalid or expired. Please check again you entered the right code, or try logging in again to receive a new code.`
              : null
          );
        }
      });
  }, [verify2FA]);

  return {
    open2FADialog,
    error2FA,
    setOpen2FADialog,
    cancel2FA,
    handleVerify2FA
  };
};
